import { type VersionAnnouncementDto } from "./version-announcement.dto";
import { useVersionAnnouncementApi } from "./version-announcement.api";
import { crudStoreFactory, type PastaCrudStoreState } from "@pasta/box-v2";

export interface VersionAnnouncementStoreState extends PastaCrudStoreState<VersionAnnouncementDto> {
  highestVersion: VersionAnnouncementDto | null;
}

export const useVersionAnnouncementStore = crudStoreFactory(
  "versions-announcement",
  useVersionAnnouncementApi,
  storeDef => {
    return {
      ...storeDef,
      state: (): VersionAnnouncementStoreState => {
        return {
          list: {
            data: [],
            isLastPage: true,
            limit: 0,
            offset: 0,
            page: 1,
            total: 0,
          },
          map: new Map<number, VersionAnnouncementDto>(),
          highestVersion: null,
        };
      },
      actions: {
        ...storeDef.actions,
        setHighestVersion(value: VersionAnnouncementDto | null) {
          this.highestVersion = value;
        },
      },
    };
  }
);
